import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import styled from "styled-components";
import ImageLibpixel from "./image-libpixel.js";

const ShortcutLinksWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  margin: 60px 0;
  @media (max-width: 1030px) {
    margin: 10px 0;
  }
  @media (max-width: 810px) {
    justify-content: flex-start;
  }
`;
const ContentBox = styled((props) => <Link {...props} />)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px 20px;
  max-width: 332px;
  width: 100%;
  height: 279px;
  border-radius: 8px;
  border: 1px solid #eaeaea;
  margin: 0 20px;
  text-decoration: none;
  cursor: pointer;
  transition: box-shadow 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  &:hover {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
  }
  @media (max-width: 1030px) {
    max-width: 220px;
    margin: 0 10px;
  }
  @media (max-width: 440px) {
    padding: 10px;
    margin: 10px 0;
    flex-direction: row;
    max-width: 340px;
    height: auto;
    align-items: center;
  }
`;
const Icon = styled(ImageLibpixel)`
  width: 57px;
  height: 58px;
  object-fit: contain;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  @media (max-width: 440px) {
    border: none;
  }
`;
const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 440px) {
    justify-content: flex-start;
    align-items: flex-start;
    padding-left: 10px;
  }
`;
const Title = styled.h3`
  font-size: 1.3rem;
  display: flex;
  text-align: center;
  font-weight: 800;
  margin-bottom: 10px;
  letter-spacing: 1px;
  text-decoration: none;
  font-family: "Poppins", sans-serif;
  @media (max-width: 1030px) {
    font-size: 1.1rem;
  }
  @media (max-width: 440px) {
    text-align: left;
    margin-top: 0;
    margin-bottom: 5px;
    font-size: 1rem;
  }
`;
const Description = styled.p`
  font-size: 1rem;
  margin: 0;
  line-height: 1.4;
  overflow: hidden;
  text-align: center;
  @media (max-width: 1030px) {
    font-size: 0.9rem;
  }
  @media (max-width: 440px) {
    text-align: left;
    font-size: 0.8rem;
  }
`;

const ShortcutLinks = ({ columns }) => {
  return (
    <ShortcutLinksWrapper>
      {columns?.map((node, i) => (
        <ContentBox key={i + 1} to={node.links?.[0]?.uri}>
          <Icon src={node.img.sourceUrl} alt={node.title} />
          <TextBox>
            <Title>{node.title}</Title>
            <Description>{node.text}</Description>
          </TextBox>
        </ContentBox>
      ))}
    </ShortcutLinksWrapper>
  );
};

ShortcutLinks.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      img: PropTypes.shape({
        sourceUrl: PropTypes.string,
      }),
      links: PropTypes.arrayOf(
        PropTypes.shape({
          uri: PropTypes.string,
          name: PropTypes.string,
        })
      ),
      title: PropTypes.string,
      text: PropTypes.string,
    })
  ),
};

ShortcutLinks.defaultProps = {
  columns: undefined,
};

export default ShortcutLinks;
